<template>
  <div
    class="onboarding-step d-flex flex-column align-items-center justify-content-center"
    :class="[
      isFirstStep && !isMobile ? 'mx-lgp row-gap-lg' : 'px-md row-gap-md',
    ]">
    <h4 class="text-center text-capitalize color-plum mb-0">
      {{ title }}
    </h4>
    <div
      v-if="text"
      class="d-flex flex-column text-center gap-md">
      <template v-if="Array.isArray(text)">
        <p
          v-for="(text, index) in text"
          :key="`text-${index}`">
          {{ text }}
        </p>
      </template>
      <template v-else>
        <p>
          {{ text }}
        </p>
      </template>
    </div>
    <div
      v-if="$slots.default || (imageUrl && !isFirstStep)"
      :class="[
        'onboarding-content',
        'd-flex flex-column align-items-center', // Necessary for Safari to properly center content.
        { 'flex-md-grow-1': !isFirstStep && (imageUrl || $slots.default) }
      ]">
      <OnboardingImage
        v-if="imageUrl && !isFirstStep"
        :src="imageUrl"
        :alt="title"
        :class="imageClass"/>
      <slot/>
    </div>
  </div>
</template>

<script setup>
import OnboardingImage from '@/components/onboarding/OnboardingImage.vue'
import useScreenSize from '@shared/composables/screenSize.js'

defineProps({
  title: {
    type: String,
    required: true
  },
  text: {
    type: [String, Array],
    default: null
  },
  imageUrl: {
    type: String,
    default: null
  },
  imageClass: {
    type: String,
    default: ''
  },
  isFirstStep: {
    type: Boolean,
    default: false
  }
})

const { isMobile } = useScreenSize()
</script>

<style lang="scss" scoped>
.onboarding-step {
  user-select: none;

  &, .onboarding-content {
    min-height: 0;
    min-width: 0;
  }
}
</style>
